import React from "react";
import PatientDashboard from "../components/PatientDashboard";

export default function PatientDetailManagement() {
  const patient = {
    name: "Ramesh Kumar",
    age: 45,
    gender: "Male",
    contact: "9876543210",
    address: "123, MG Road, Indore, MP, India",
    admissionDate: "2023-11-01",
    doctor: "Dr. Mukesh Phalak",
    ward: "Ward 101",
    bed: "Bed 5",
    emergencyContact: "Anita Kumar (Wife) - 9876543211",
  };

  const vitals = [
    {
      date: "2023-11-01",
      temperature: 98.6,
      bloodPressure: "120/80",
      heartRate: 72,
      respiratoryRate: 16,
    },
    {
      date: "2023-11-02",
      temperature: 99.0,
      bloodPressure: "125/85",
      heartRate: 74,
      respiratoryRate: 18,
    },
    {
      date: "2023-11-03",
      temperature: 97.8,
      bloodPressure: "118/78",
      heartRate: 70,
      respiratoryRate: 15,
    },
  ];

  const treatments = [
    {
      name: "Appendectomy",
      status: "Completed",
      date: "2023-11-02",
      doctor: "Dr. Mukesh Phalak",
      notes: "Surgery performed successfully. No complications observed.",
    },
    {
      name: "Post-Surgical Physiotherapy",
      status: "Ongoing",
      date: "2023-11-03",
      doctor: "Dr. Anuja Phalak",
      notes: "Patient is responding well to the physiotherapy sessions.",
    },
  ];

  const billing = {
    items: [
      { description: "Ward Stay (3 days)", amount: 4500, paid: true },
      { description: "Surgery", amount: 15000, paid: true },
      { description: "Medications", amount: 2500, paid: false },
      { description: "Physiotherapy (2 sessions)", amount: 2000, paid: false },
    ],
    total: 24000,
    due: 4500,
  };

  return (
    <PatientDashboard
      billing={billing}
      patient={patient}
      treatments={treatments}
      vitals={vitals}
    />
  );
}
